import { useCallback } from "react";
import toast from "react-hot-toast";

export const useLinkedNoteHandler = ({
  handleLinkedNoteClickHook,
  memoizedDisplayNotes,
  handleRowClick,
  viewMode
}) => {
  const handleLinkedNoteClick = useCallback((replyNoteId, e) => {
    const result = handleLinkedNoteClickHook(replyNoteId, e);
    if (!result || !result.originalNoteId) return;

    const originalNoteId = result.originalNoteId;
    const originalNote = memoizedDisplayNotes.find(
      (n) => n.id === originalNoteId,
    );

    if (originalNote) {
      handleRowClick(originalNote);

      setTimeout(() => {
        let noteElement = null;

        if (viewMode === "table") {
          noteElement = document.querySelector(
            `tr[data-note-id="${originalNoteId}"]`,
          );
        } else if (viewMode === "cards" || viewMode === "stacked") {
          noteElement = document.querySelector(
            `.note-card[data-note-id="${originalNoteId}"]`,
          );
        }

        if (noteElement) {
          noteElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });

          noteElement.classList.add("highlight-original-note");

          setTimeout(() => {
            noteElement.classList.remove("highlight-original-note");
          }, 2000);
        } else {
          toast.error(
            `Note (ID: ${originalNoteId}) not found in current view.`,
          );
        }
      }, 100);
    } else {
      toast.error(
        `Original note (ID: ${originalNoteId}) not found in current view.`,
      );
    }
  }, [handleLinkedNoteClickHook, memoizedDisplayNotes, handleRowClick, viewMode]);

  return { handleLinkedNoteClick };
};